import { createContext } from 'react';

export default createContext({
  // WEB-5358 will be added in the future
  // activePeriod: 'annual',
  year: 2023,
});
